import {
    AUTH_API_URL,
    ROLE_ADMIN,
    ROLE_USER,
    ROLE_DESIGNER,
    ROLE_WORKER,
    ROLE_SERVICE,
    ROLE_KHAC,
    ROLE_KIM,
    ROLE_XI,        
    ROLE_SHIPPING,
    ROLE_SHIPPING_D,
    ROLE_SUPERVISOR,
    ROLE_BONG,
    ROLE_NHAM,
    STATUS_NAME_LEN,
    STATUS_NAME_DA,
    ROLE_DELIVERY,
    ROLE_QUALITY,
    ROLE_HOANTHANH
} from '../constants';
import axios from 'axios';
export const USER_TOKEN = 'token';
export const USER_ROLES = 'roles';
export const USER_NAME = 'username';
export const USER_ID = 'userId';
export const WORKING_SHOP = 'workingShop';
export const LIMIT_USER = 'limitUser';
export const DEPARTMENT = 'department';
export const BCPRINT = 'bcprint';
export const DCPRINT = 'dcprint';

class AuthenticationService {

    
    registerSuccessfulLogin(token, roles, username, userId, workingShop, limitUser, department, bcprint, dcprint) {
        sessionStorage.clear();
        sessionStorage.setItem(USER_TOKEN, token);
        sessionStorage.setItem(USER_ROLES, roles);
        sessionStorage.setItem(USER_NAME, username);
        sessionStorage.setItem(USER_ID, userId);
        sessionStorage.setItem(WORKING_SHOP, workingShop);
        sessionStorage.setItem(LIMIT_USER, limitUser);
        sessionStorage.setItem(DEPARTMENT, department);
        sessionStorage.setItem(BCPRINT, bcprint);
        sessionStorage.setItem(DCPRINT, dcprint);
    }

    executeBasicAuthenticationService(username, password, macAddress) {
        const request = new Request(`${AUTH_API_URL}`, {
            method: 'POST',
            body: JSON.stringify({ username, password, macAddress }),
            headers: new Headers({ 
                'Content-Type': 'application/json',
                cors : {
                    origin: ["*"],
                    headers: ["Access-Control-Allow-Origin","Access-Control-Allow-Headers","Origin, X-Requested-With, Content-Type"]
                },
                Accept: 'application/json'
            }),
        })

        return fetch(request)
        .then(response => {
            if (response.status < 200 || response.status >= 300) {
                throw new Error(response.statusText);
            }
            return response.json();
        }).catch(function(error) {
            throw error;
        });
    }

    getMacAddress() {
        return axios.get(`http://localhost:6868/settings`
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    logout() {
        sessionStorage.clear();
        let tmp = localStorage.getItem("labelValues");
        localStorage.clear();
        localStorage.setItem("labelValues", tmp);
    }

    isUserLoggedIn() {
        let user = sessionStorage.getItem(USER_TOKEN);
        if ((user === null) || (user === undefined)) return false
        return true
    }

    getLoggedInUserToken() {
        let token = sessionStorage.getItem(USER_TOKEN)
        if (token === null) return ''
        return token
    }

    getLoggedInUsername() {
        return sessionStorage.getItem(USER_NAME);
    }

    getLoggedInUserRoles() {
        return sessionStorage.getItem(USER_ROLES);
    }

    getRole(){
        var roles = sessionStorage.getItem(USER_ROLES);
        if ((roles === null) || (roles === undefined)){
            return "";
        }
        var arrRoles = roles.split(",");
        if (arrRoles.length <= 0){
            return "UNNOWN_ROLE";
        }
        return arrRoles[0];
    }

    hasRole(role){
        var roles = sessionStorage.getItem(USER_ROLES);
        if ((roles === null) || (roles === undefined)){
            return false;
        }
        var arrRoles = roles.split(",");
        for(var i=0; i< arrRoles.length;i++){
            if (role.toUpperCase() === arrRoles[i]){
                return true;
            }
        }
        return false;
    }

    getUserId(){
        return sessionStorage.getItem(USER_ID);
    }

    getUserName(){
        return sessionStorage.getItem(USER_NAME);
    }

    isAdmin(){
        return this.hasRole(`${ROLE_ADMIN}`);
    }

    isKcs(){
        return this.hasRole(`${ROLE_HOANTHANH}`);
    }

    isWorker(){
        return this.hasRole(`${ROLE_WORKER}`);
    }

    isKhac(){
        return this.hasRole(`${ROLE_KHAC}`);
    }

    isKim(){
        return this.hasRole(`${ROLE_KIM}`);
    }

    isDelivery(){
        return this.hasRole(`${ROLE_DELIVERY}`);
    }

    isQuality(){
        return this.hasRole(`${ROLE_QUALITY}`);
    }



    isLen(){
        if (!this.isWorker()){
            return false;
        }

        let department = sessionStorage.getItem("department") ;
        if (department === undefined || department === null){
            return false;
        } 

        if (department.toLowerCase() !== STATUS_NAME_LEN.toLowerCase()){
            return false;
        }

        return true;
    }

    isDa(){
        if (!this.isWorker()){
            return false;
        }

        let department = sessionStorage.getItem("department") ;
        if (department === undefined || department === null){
            return false;
        } 

        if (department.toLowerCase() !== STATUS_NAME_DA.toLowerCase()){
            return false;
        }

        return true;
    }

    isBong(){
        return this.hasRole(`${ROLE_BONG}`);
    }

    isNham(){
        return this.hasRole(`${ROLE_NHAM}`);
    }

    isXi(){
        return this.hasRole(`${ROLE_XI}`);
    }    

    isShipping(){
        return this.hasRole(`${ROLE_SHIPPING}`) || this.hasRole(`${ROLE_SHIPPING_D}`);
    }

    isDesigner(){
        return this.hasRole(`${ROLE_DESIGNER}`);
    }

    isService(){
        return this.hasRole(`${ROLE_SERVICE}`);
    }

    isUser(){
        return this.hasRole(`${ROLE_USER}`);
    }

    isSupervisor(){
        return this.hasRole(`${ROLE_SUPERVISOR}`);
    }    
}

export default new AuthenticationService();